/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import React, { FC, ReactNode, useState } from 'react';
import { SplitPromptSequenceContext } from '@/context';
import { SplitPayload } from 'types/prompt-sequence-view';

export const SplitPromptSequenceProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [splitPayload, setSplitPayload] = useState<SplitPayload | null>(null);

  return (
    <SplitPromptSequenceContext.Provider
      value={{ splitPayload, setSplitPayload }}
    >
      {children}
    </SplitPromptSequenceContext.Provider>
  );
};
